/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_See_TermsInputs */

const en_legal_see_terms = /** @type {(inputs: Legal_See_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const id_legal_see_terms = /** @type {(inputs: Legal_See_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketentuan Layanan`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Legal_See_TermsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const legal_see_terms = /** @type {((inputs?: Legal_See_TermsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_See_TermsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_legal_see_terms(inputs)
	return en_legal_see_terms(inputs)
});